import type { StatefulTrackerViewT } from "../../../types/database/trackers";
import { useDiaryByIdQuery } from "../../diaries/api";
import { extractTrackerById } from "../../diaries/services/extractTrackerById";

const useExtractTracker = (
	diaryId: string,
	trackerId: string,
): StatefulTrackerViewT => {
	const { data: diary } = useDiaryByIdQuery(diaryId);
	return extractTrackerById(diary, trackerId) as StatefulTrackerViewT;
};

export default useExtractTracker;
